import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import { FaPlus, FaMinus } from "react-icons/fa"
import "@fontsource/raleway/600.css"
import "@fontsource/raleway/700.css"
import { useTransition, animated, config } from "react-spring"
import { useMediaQuery } from "react-responsive"
import useCovidConditional from "../../hooks/useCovidConditional.ts"
import useGalleryConditional from "../../hooks/useGalleryConditional.ts"

type PropTypes = {
  slug: string
  vis: boolean
  subNavArr?: any
}

const NavLi = styled.li`
  margin: 0 0 10px 15px;
  background-color: ${colors("grey", "dk")};
  border-left: 2px solid ${colors("grey")};
  display: flex;
  align-items: center;
  &.hidden {
    display: none;
  }
  & > a,
  & > button {
    color: ${colors("green", "lnklt")};
    &:hover {
      color: ${colors("green", "lnklthlt")};
    }
  }
  &:before {
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-left: 6px solid ${colors("grey")};
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    margin-right: 10px;
  }
  &.NavItem--subNav {
    background-color: transparent;
    border-left: none;
    margin: 0;
    margin-left: 15px;
    &:before {
      display: none;
    }
  }
  @media screen and (min-width: 1024px) {
    background-color: ${props =>
      props.headerType === "default" ? colors("grey", "dk") : "white"};
    & > a,
    & > button {
      color: ${(props: any) =>
        props.headerType === "default"
          ? colors("green", "lnklt")
          : colors("green", "lnk")};
      &:hover {
        color: ${(props: any) =>
          props.headerType === "default"
            ? colors("green", "lnklthlt")
            : colors("green", "lnkhlt")};
      }
    }
    &,
    &.NavItem--subNav {
      position: relative;
      width: 67px;
      border-left: none;
      justify-content: center;
      margin-bottom: 0;
      background-color: transparent;
      &:before {
        display: none;
      }
    }
  }
  @media screen and (min-width: 1500px) {
    &,
    &.NavItem--subNav {
      width: 72px;
      margin-left: 25px;
      display: flex;
      cursor: pointer;
      padding: initial;
      & > a,
      & > button {
        justify-content: space-between;
        padding: 0;
      }
    }
  }
`

const NavLink = styled(Link)`
  display: block;
  font-size: 15px;
  font-weight: 700;
  line-height: 1em;
  text-transform: uppercase;
  font-family: "Raleway", sans-serif;
  transition: all 0.25s;
  padding: 13px 13px 10px 0;
  @media screen and (min-width: 1024px) {
    height: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    color: ${colors("green", "lnklt")};
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    &:hover {
      color: ${colors("green", "lnklthlt")};
    }
    button& {
      margin-top: -1.5px;
    }
  }
`

const outerWidth = 17
const innerWidth = 10

const NavTriangle = styled.div`
  display: none;
  position: relative;
  width: 0px;
  height: 0px;
  border-bottom: ${outerWidth}px solid ${colors("grey")};
  border-right: ${outerWidth}px solid transparent;
  border-left: ${outerWidth}px solid transparent;
  &:after {
    position: absolute;
    bottom: -${outerWidth}px;
    right: -50%;
    transform: translateX(50%);
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-bottom: ${innerWidth}px solid white;
    border-right: ${innerWidth}px solid transparent;
    border-left: ${innerWidth}px solid transparent;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
  .NavItem--subNav & {
    /* margin-bottom: -1px; */
  }
`

const SubNavIndicatorStyles = styled.div`
  display: none;
  background-color: white;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  top: 33px;
  transform: rotate(45deg);
  z-index: 100;
  @media screen and (min-width: 1024px) {
    display: flex;
  }
  div {
    background-color: ${colors("green", "lnk")};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 13px;
    height: 13px;
    z-index: 100;
    transition: all 0.25s;
  }
  svg {
    transform: rotate(-45deg);
    color: white;
    height: 11px;
  }
  .NavItem--subNav:hover & div {
    background-color: ${colors("green", "lnkhlt")};
  }
`

const SubNavIndicator = ({ open }) => (
  <SubNavIndicatorStyles>
    <div>{open ? <FaMinus /> : <FaPlus />}</div>
  </SubNavIndicatorStyles>
)

const SubNav = styled.div`
  @media screen and (min-width: 1024px) {
    position: absolute;
    top: 50px;
    left: 0;
    padding-top: 20px;
  }
`

const SubNavUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

const SubNavItem = styled.li`
  margin: 0 0 10px;
  background-color: ${colors("grey", "dk")};
  border-left: 2px solid ${colors("grey")};
  display: flex;
  align-items: center;
  a,
  button {
    color: ${colors("green", "lnklt")};
    &:hover {
      color: ${colors("green", "lnklthlt")};
    }
  }
  &:before {
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    border-left: 6px solid ${colors("grey")};
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    margin-right: 10px;
  }
  @media screen and (min-width: 1024px) {
    background-color: ${props =>
      props.headerType === "default" ? colors("grey", "dk") : "white"};
    a,
    button {
      color: ${(props: any) =>
        props.headerType === "default"
          ? colors("green", "lnklt")
          : colors("green", "lnk")};
      &:hover {
        color: ${(props: any) =>
          props.headerType === "default"
            ? colors("green", "lnklthlt")
            : colors("green", "lnkhlt")};
      }
    }
  }
`

const SubNavLink = styled(Link)`
  display: block;
  font-size: 15px;
  font-weight: 700;
  line-height: 1em;
  text-transform: uppercase;
  padding: 13px 13px 10px 0;
`

const NavItem: React.FC<PropTypes> = ({
  children,
  slug,
  subNavArr,
  external,
  headerType,
  vis,
}) => {
  const [open, setOpen] = useState(false)

  const navItemRef = useRef(null)

  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" })

  const clickOutsideHandler = event => {
    if (
      isDesktop &&
      (!navItemRef.current || !navItemRef.current.contains(event.target))
    ) {
      setOpen(false)
    }
  }

  useEffect(() => {
    if (!isDesktop) {
      setOpen(true)
    }
    document.addEventListener("mousedown", clickOutsideHandler)
    return () => {
      document.removeEventListener("mousedown", clickOutsideHandler)
    }
  }, [])

  const transitionOpacity = isDesktop ? 1 : 0
  const transitionVert = isDesktop ? 0 : -100

  const transitions = useTransition(open, {
    from: { opacity: 0, y: -100 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: -100 },
    reverse: open,
    config: {
      duration: 250,
    },
  })

  const subNavClass = subNavArr ? "NavItem--subNav" : ""

  const visClass = vis ? "visible" : "hidden"

  const hasGalleryMedia = useGalleryConditional()

  const hasCovidInfo = useCovidConditional()

  const SubNavUlComponent = () => (
    <SubNavUl>
      {subNavArr
        ? subNavArr.map((subNavItem, index) => {
            const subNavConditional = () => {
              if (subNavItem.text === "Gallery" && !hasGalleryMedia) {
                return false
              }
              if (subNavItem.text === "Covid" && !hasCovidInfo) {
                return false
              }
              return true
            }

            return subNavConditional() ? (
              <SubNavItem
                onClick={() => {
                  isDesktop && setOpen(false)
                }}
                headerType={headerType}
                key={subNavItem.slug}
              >
                <SubNavLink to={subNavItem.slug}>{subNavItem.text}</SubNavLink>
              </SubNavItem>
            ) : null
          })
        : null}
    </SubNavUl>
  )

  return (
    <NavLi
      className={`${subNavClass} ${visClass}`}
      onClick={() => {
        isDesktop && setOpen(!open)
      }}
      ref={navItemRef}
      headerType={headerType}
    >
      <NavLink
        to={slug}
        href={slug}
        as={subNavArr ? "button" : external ? "a" : Link}
      >
        {children}
        <NavTriangle />
      </NavLink>
      {subNavArr && (
        <>
          <SubNavIndicator open={open} />
          <SubNav open={open}>
            {isDesktop ? (
              transitions(
                (styles, item) =>
                  item && (
                    <animated.div style={styles}>
                      <SubNavUlComponent />
                    </animated.div>
                  )
              )
            ) : (
              <SubNavUlComponent />
            )}
          </SubNav>
        </>
      )}
    </NavLi>
  )
}

export default NavItem
